import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

export default function Profile(props) {
    const [open, setOpen] = React.useState(false);
    // console.log(props.mapdata)
    // console.log('Main', props.data)

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <React.Fragment>
            {/* <Button variant="outlined" size='sm' onClick={props.data?.openProfile}>
                View
            </Button> */}
            <Dialog
                fullWidth={true}
                maxWidth='md'
                open={props.open}
                onClose={() => props.setOpenProfile(false)}
            >
                <DialogTitle>Profile</DialogTitle>
                <DialogContent>
                    <div>
                        <div className="profile">
                            <div className='d-flex justify-content-center'>
                                <img src="https://t4.ftcdn.net/jpg/03/32/59/65/240_F_332596535_lAdLhf6KzbW6PWXBWeIFTovTii1drkbT.jpg" alt="" width={120} className='rounded-circle' />
                            </div>
                            <hr />
                        </div>

                        <div className='m-3'>
                            <div className="row  border rounded">
                                <div className="col-12 text-center p-3">
                                    <strong> Personal Details </strong>
                                    <hr style={{ borderTop: 'dotted 1px' }} className='m-0 p-0' />
                                </div>
                                <div className="col-md-6 py-2">
                                    <label htmlFor="">Emp Code: </label> <strong>{props.data?.uuid}</strong>
                                </div>
                                <div className="col-md-6 py-2">
                                    <label htmlFor="">Name: </label> <strong>{props.data?.name}</strong>
                                </div>
                                <div className="col-md-6 py-2">
                                    <label htmlFor="">DOB: </label> <strong>
                                        {/* {props.data?.dob} */}
                                        {new Date(props.data?.dob).getDate()
                                            + ", " +
                                            new Date(props.data?.dob).toLocaleString("default", { month: "long", })
                                            + "-" +
                                            new Date(props.data?.dob).getFullYear()}
                                    </strong>
                                </div>
                                <div className="col-md-6 py-2">
                                    <label htmlFor="">Email: </label> <strong>{props.data?.email}</strong>
                                </div>
                                <div className="col-md-6 py-2">
                                    <label htmlFor="">Phone: </label> <strong>{props.data?.phone}</strong>
                                </div>
                                <div className="col-md-6 py-2">
                                    <label htmlFor="">Gender: </label> <strong>{props.data?.gender == 'male' ? 'Male' : 'Female'}</strong>
                                </div>

                                <div className="col-md-6 py-2">
                                    <label htmlFor="">Current Address: </label> <strong>{props.data?.currentAddress ? props.data?.currentAddress : '--'}</strong>
                                </div><div className="col-md-6 py-2">
                                    <label htmlFor="">Permanent Address: </label> <strong>{props.data?.permanentAddress ? props.data?.permanentAddress : '--'}</strong>
                                </div>

                                <div className="col-md-6 py-2">
                                    <label htmlFor="">Emergency Conatact: </label> <strong>{props.data?.emergencyContactNumber ? props.data?.emergencyContactNumber : '--'}</strong>
                                </div>



                                {/* <div className="col-md-6 py-2">
                                    <label htmlFor="">Status: </label> <strong>{props.data?.status}</strong>
                                </div> */}
                            </div>
                        </div>


                        <div className='m-3'>
                            <div className="row  border rounded">
                                <div className="col-12 text-center p-3">
                                    <strong> Employement Details </strong>
                                    <hr style={{ borderTop: 'dotted 1px' }} className='m-0 p-0' />
                                </div>

                                <div className="col-md-6 py-2">
                                    <label htmlFor="">Employement Type: </label> <strong>{props.data?.employementType}</strong>
                                </div>
                                <div className="col-md-6 py-2">
                                    <label htmlFor="">Roles: &nbsp; </label>
                                    <strong>
                                        {(props.data?.roles?.map((d) => {
                                            if (typeof d == 'object') {
                                                return `${d.name || ''}`
                                            }
                                            return `${props.mapdata?.Roles[d]?.name || ''}`
                                        }) || []).join(", ")}
                                    </strong>
                                </div>
                                <div className="col-md-6 py-2">
                                    <label htmlFor="">Designation: &nbsp; </label>
                                    <strong>
                                        {(props.data?.designations?.map((d) => {
                                            if (typeof d == 'object') {
                                                return `${d.name || ''}`
                                            }
                                            return `${props.mapdata?.Designations[d]?.name || ''}`
                                        }) || []).join(", ")}
                                    </strong>
                                </div>
                                <div className="col-md-6 py-2">
                                    <label htmlFor="">Department: &nbsp; </label>
                                    <strong>
                                        {(props.data?.departments?.map((d) => {
                                            if (typeof d == 'object') {
                                                return `${d.name || ''}`
                                            }
                                            return `${props.mapdata?.Departments[d]?.name || ''}`
                                        }) || []).join(", ")}
                                    </strong>
                                </div>
                                <div className="col-md-6 py-2">
                                    <label htmlFor="">Department Type: </label> <strong>{props.data?.department_type}</strong>
                                </div>

                                <div className="col-md-6 py-2">
                                    <label htmlFor="">Date of Joining: </label> <strong>
                                        {new Date(props.data?.dateOfJoining).getDate()
                                            + ", " +
                                            new Date(props.data?.dateOfJoining).toLocaleString("default", { month: "long", })
                                            + "-" +
                                            new Date(props.data?.dateOfJoining).getFullYear()}
                                    </strong>
                                </div>
                                <div className="col-md-6 py-2">
                                    <label htmlFor="">Assigned Roles: &nbsp; </label>
                                    <strong>
                                        {(props.data?.assignedRoles?.map((d) => (`${props.mapdata?.TaskTypes[d]?.name || ''}`)) || []).join(", ")}
                                    </strong>
                                </div>
                                <div className="col-md-6 py-2">
                                    <label htmlFor="">Reporting Manager: &nbsp; </label>
                                    <strong>
                                        {
                                            props.mapdata?.users &&
                                            <>
                                                {`${props.mapdata?.users[props.data?.reportingManager]?.name || '--'}`}
                                            </>
                                        }
                                    </strong>
                                </div>
                                <div className="col-md-6 py-2">
                                    <label htmlFor="">POC: &nbsp; </label>
                                    <strong>
                                        {
                                            props.mapdata?.users &&
                                            <>
                                                {`${props.mapdata?.users[props.data?.pocForLeaves]?.name || '--'}`}
                                            </>
                                        }
                                    </strong>
                                </div>

                                <div className="col-md-6 py-2">
                                    <label htmlFor="">Languages: &nbsp; </label>
                                    <strong>
                                        {props.data?.languages?.map((d) => (<> {props.mapdata?.Languages[d].name}, </>))}


                                    </strong>
                                </div>

                                <div className="col-md-6 py-2">
                                    <label htmlFor="">Status: </label> <strong>{props.data?.status}</strong>
                                </div>
                            </div>
                        </div>

                        {/* Ozonetel Details */}
                        <div className="m-3">
                            <div className="row  border rounded">
                                <div className="col-12 text-center p-3">
                                    <strong> Ozonetel Details </strong>
                                    <hr style={{ borderTop: 'dotted 1px' }} className='m-0 p-0' />
                                </div>
                                <div className="col-md-6 py-2">
                                    <label htmlFor="">Agent ID: </label> <strong>{props.data?.agentId}</strong>
                                </div>
                            </div>
                        </div>

                        {/* End Ozonetel Details */}

                        <div className="m-3">
                            <div className="row  border rounded p-2 justify-content-center">
                                <div className='p-1'>
                                    <Button variant='outlined' size='small' onClick={props.onClickEdit}> <EditIcon /> Edit</Button>
                                </div>
                                {
                                    !props.hideDelete &&
                                    <div className='p-1'>
                                        <Button variant='outlined' size='small' onClick={props.onClickDelete}><DeleteIcon /> Delete</Button>
                                    </div>
                                }

                            </div>
                        </div>



                    </div>





                </DialogContent>
                <DialogActions>
                    <Button onClick={() => props.setOpenProfile(false)}>Close</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
